module.exports = __webpack_public_path__ + "site/img/renewzh.2be421c6.png";